// extracted by mini-css-extract-plugin
export var block = "footerProducts-module--block--dCpVn";
export var sites = "footerProducts-module--sites--Z0BO7";
export var ligal = "footerProducts-module--ligal--n56gB";
export var phone = "footerProducts-module--phone--L44PL";